module.exports = __webpack_public_path__ + "static/media/cwiczenie_4.6a9691d0.jpg";